define.alias("shared/utils/array-filters/get-sum-of-extracted-values", "calendar/utils/array-filters/get-sum-of-extracted-values");